import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const FlightFilter = ({ handleFilterChange, filters }) => {
    const lang = useSelector((state) => state.culture.language);
    const [isWithFlight, setIsWithFlight] = useState(false);


    const handleCheckboxChange = () => {
        const newValue = !isWithFlight;
        setIsWithFlight(newValue);
        handleFilterChange("typeFilter", newValue ? "Flight" : null); // Notify parent
    };

    useEffect(() => {
        setIsWithFlight(filters.typeFilter)
    }, [filters])

    return (
        <div className="Filterbox">
            <div className="Filterhead d-flex justify-content-between">
                <div className="FilterTitle d-flex">{lang.flight}</div>
                <div>
                    {" "}
                    <span className="filter_clear">
                        <a href={undefined} onClick={()=>handleFilterChange('typeFilter', null)}>{lang.clear}</a>
                    </span>{" "}
                </div>
            </div>
            <div className="FilterContent fareType td-checkbox">
                <ul>
                    <li>
                        <input
                            type="checkbox"
                            id="opby1"
                            checked={isWithFlight}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="opby1">{lang.with_flight || 'with flight'}</label>
                    </li>

                </ul>
            </div>
        </div>
    )
}

export default FlightFilter